<template>
  <div>
    <page-content-toolbar
      :projectName="`${project && project.name ? project.name : ' '}`"
      :title="$t('sourcesAndDeployments.generateSources')"
    />

    <v-container class="px-12 pt-7 pb-1 mt-2" fluid>
      <h3>{{ $t('sourcesAndDeployments.generateSources') }}</h3>
      <v-row>
        <v-col cols="12">
          <v-text-field
            :label="$t('sourceViewer.version')"
            v-model="selectedVersion"
            :rules="[rules.required, rules.pattern]"
            counter
            maxlength="20"
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="2">
          <raison-button
            :button-label="$t('sourceViewer.generate')"
            :button-function="generateSource"
            :loading="loading"
            :disabled="selectedVersion === undefined || !testVersion(selectedVersion)"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>  
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import RaisonButton from '@/components/global/RaisonButton';

import projectPageMixin from '@/mixins/project-page-mixin.js';
import userRightMixin from '@/mixins/user-right-mixin.js';

import generationService from '@/services/generations.js';
import { testVersion } from '@/utils/utils.js';


export default {
  name: 'GenerateSource',

  mixins: [ projectPageMixin, userRightMixin ],

  components: { PageContentToolbar, RaisonButton },

  data () {
    return {
      rules: {
        required: value => !!value || this.$t('uploadSource.rule.required'),
        pattern: value =>  testVersion(value) || this.$t('uploadSource.rule.versionMustMatchPattern'),
      },
      selectedVersion: undefined,
      loading: false,
    };
  },

  methods: {
    testVersion: testVersion,

    generateSource () {
      this.loading = true;
      let projectId = this.$route.params.id;
      generationService.generate(projectId, this.selectedVersion).then(response => {
        this.$router.push({name: 'sourceViewer', params: { id: projectId, sourceId: response.data.generatedSource.id } });
      }).catch(err => {
        this.loading = false;
        this.$emit('raison-event', { type: 'error', messages: [err] });
      });
    },
  },

  created () {
    if (!this.isUserParameterizer) {
      this.$router.push({name: 'dashboard'});
    }
  },
};
</script>

<style>

</style>